module.exports = __webpack_public_path__ + "static/img/product_six.e51b76b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_six.png
// module id = APh/
// module chunks = 1